module.exports = __webpack_public_path__ + "static/media/baner_wakaf.5594bb60.png";